import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowLeft = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_22362_9906)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M0.584713 9.41293L3.16471 12.0196C3.22669 12.0821 3.30042 12.1317 3.38166 12.1655C3.4629 12.1994 3.55004 12.2168 3.63805 12.2168C3.72605 12.2168 3.81319 12.1994 3.89443 12.1655C3.97567 12.1317 4.0494 12.0821 4.11138 12.0196C4.23555 11.8947 4.30524 11.7257 4.30524 11.5496C4.30524 11.3735 4.23555 11.2045 4.11138 11.0796L1.73805 8.68627L15.3314 8.68626C15.5082 8.68626 15.6778 8.61603 15.8028 8.491C15.9278 8.36598 15.998 8.19641 15.998 8.0196C15.998 7.84279 15.9278 7.67322 15.8028 7.54819C15.6778 7.42317 15.5082 7.35293 15.3314 7.35293L1.69805 7.35293L4.11138 4.94626C4.17386 4.88429 4.22346 4.81056 4.25731 4.72932C4.29115 4.64808 4.30858 4.56094 4.30858 4.47293C4.30858 4.38492 4.29115 4.29779 4.25731 4.21655C4.22346 4.13531 4.17386 4.06157 4.11138 3.9996C4.0494 3.93711 3.97567 3.88752 3.89443 3.85367C3.81319 3.81982 3.72605 3.8024 3.63805 3.8024C3.55004 3.8024 3.4629 3.81982 3.38166 3.85367C3.30042 3.88752 3.22669 3.93711 3.16471 3.9996L0.584712 6.58627C0.210178 6.96127 -0.000194011 7.4696 -0.000193965 7.9996C-0.000193918 8.5296 0.210178 9.03793 0.584713 9.41293Z",
			fill: "#333333"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_22362_9906",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgArrowLeft;
